
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/gift-credit",
      function () {
        return require("private-next-pages/dashboard/gift-credit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/gift-credit"])
      });
    }
  